<template>
    <div :class="['block-wrapper', componentClass, colorMode, {visible: visible, ready: ready}]">
		<div class="columns small-12 xlarge-10 xlarge-offset-1 xxlarge-8 xxlarge-offset-2">
            <h1 v-if="data.page_title">{{ data.page_title }}</h1>
            <base-table v-bind:data="data" ></base-table>
		</div>
	</div>
</template>

<script>
import BaseBlock from './Base'
export default {
    extends: BaseBlock,
    data() {
        return {
            defaultColorMode: 'light',
            componentClass: 'table-wrapper',
        }
    },
	components: {
		BaseTable: () => import('./table/Table')
	},
}
</script>
